<template>
<svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Nv`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6879 4.78672C11.6879 6.94063 9.94183 8.68672 7.78792 8.68672C7.06367 8.68672 6.38552 8.4893 5.80437 8.14533C5.78188 8.18018 5.75543 8.2132 5.72499 8.24377L5.20051 8.77055L6.22499 9.79256C6.45959 10.0266 6.46004 10.4065 6.22601 10.6411C5.99198 10.8757 5.61208 10.8761 5.37748 10.6421L4.35384 9.62093L3.04387 10.9366C2.81007 11.1715 2.43017 11.1723 2.19534 10.9385C1.96051 10.7047 1.95968 10.3248 2.19349 10.09L3.50429 8.77343L2.52916 7.80065C2.29457 7.56662 2.29411 7.18672 2.52814 6.95212C2.76217 6.71752 3.14207 6.71706 3.37667 6.9511L4.35096 7.92304L4.87461 7.3971C4.87736 7.39433 4.88014 7.3916 4.88294 7.3889C4.26422 6.69865 3.88792 5.78663 3.88792 4.78672C3.88792 2.63281 5.63401 0.886719 7.78792 0.886719C9.94183 0.886719 11.6879 2.63281 11.6879 4.78672ZM10.5523 4.81589C10.5523 6.33467 9.32103 7.56589 7.80225 7.56589C6.28347 7.56589 5.05225 6.33467 5.05225 4.81589C5.05225 3.29711 6.28347 2.06589 7.80225 2.06589C9.32103 2.06589 10.5523 3.29711 10.5523 4.81589Z" :fill="useCurrentColor ? 'currentColor' : '#E5557F'"/></svg>
</template>
<script>

export default {
  name: 'IconNv',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
